export const adjustOverlaySizeTo = async (spreadContainerElement: HTMLElement) => {
  if (spreadContainerElement.clientWidth && spreadContainerElement.clientHeight) {
    setTimeout(() => {
      const overlayElem = document.querySelector('.gc-overlay') as HTMLElement;
      overlayElem.style.position = 'relative';
      overlayElem.style.width = `${spreadContainerElement.clientWidth}px`;
      overlayElem.style.height = `${spreadContainerElement.clientHeight}px`;
      // Remove the drag and fill options widget
      // spreadContainerElement.querySelector('#gc-dialog2').remove();
    });
  }
};
